import { Container, Text } from "@chakra-ui/react";
import React from "react";

const Footer = () => {
  return (
    <Container textAlign="center" id="Footer">
      <Text fontSize="1.2rem" fontWeight="semibold">
        Made with ❤️ by Sunil Kumar
      </Text>
    </Container>
  );
};

export default Footer;
